import type { OtherLocation, OtherLocationOpeningHoursInfoStateEnum } from "@mobility-item-page/dealer";
import { Badge } from "@warp-ds/elements/react/badge";
import { Card } from "@warp-ds/elements/react/card";
import { Clickable } from "@warp-ds/react";
import { trackBrandingPage, trackSeeOtherLocation } from "src/utils/pulseHelper.ts";
import { useAppConfig } from "../../../context/AppConfigProviderContext.tsx";
import { Icon } from "../Icon.tsx";
import "./card.css";
import { Image } from "./Image.tsx";

const LocationCard = ({ name, profileImageUrl, location, openingHoursInfo, dealerBrandingPage }: OtherLocation) => {
  const badgeVariantMap: Record<
    OtherLocationOpeningHoursInfoStateEnum,
    "positive" | "warning" | "negative" | "neutral"
  > = {
    Open: "positive",
    ClosingSoon: "warning",
    Closed: "negative",
    ByAppointment: "neutral",
  };
  const { googleMapsEmbed } = useAppConfig();
  const mapsLink =
    googleMapsEmbed && location?.mapInfo?.linkTitle
      ? `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(location?.mapInfo?.linkTitle)}`
      : location?.mapInfo?.linkUrl;

  return (
    <article className="w-[304px] md:w-unset md:min-w-[calc((100%_-_3.2rem)/3)] card-container">
      <Card className="overflow-hidden rounded-8 hover:overflow-visible w-[304px] md:w-unset md:min-w-[calc((100%_-_3.2rem)/3)]">
        <Clickable
          href={dealerBrandingPage.linkUrl}
          className="z-10"
          onClick={() => trackBrandingPage(dealerBrandingPage.linkUrl, name)}
        >
          <div className="aspect-14/9">
            <Image image={profileImageUrl} altText={name} />
          </div>
        </Clickable>
      </Card>
      <div className="flex flex-col gap-4">
        <h3 className="card-title">{name}</h3>
        {location?.mapInfo && (
          <address className="flex items-center gap-8 not-italic">
            <div className="flex gap-8">
              <Icon name="PinMarker" className="aria-hidden mt-2" />
              <span className="sr-only">,</span>
              <a
                href={mapsLink}
                onClick={() => trackSeeOtherLocation(mapsLink)}
                target="_blank"
                rel="noreferrer"
                className=""
              >
                {location.mapInfo?.linkTitle}
              </a>
            </div>
          </address>
        )}
        {openingHoursInfo && (
          <Badge variant={badgeVariantMap[openingHoursInfo.state]} className="w-max">
            {openingHoursInfo.stateText}
          </Badge>
        )}
      </div>
      <a
        href={dealerBrandingPage.linkUrl}
        onClick={() => trackBrandingPage(dealerBrandingPage.linkUrl, name)}
        className="flex items-center gap-4"
      >
        {dealerBrandingPage.linkTitle}
        <Icon name="ArrowRight" />
      </a>
    </article>
  );
};

export default LocationCard;
